<template>
  <div>
    <div v-if="currentJewelSelection">
      <div v-if="
        options &&
        options.length > 0 &&
        currentJewelSelection.productType !== 'KIT'
      ">
        <div class="col-12 mb-3" v-for="(option, index) in options" :key="option.id">
          <div class="option-label border-left-0">
            <div class="text-right info-button-parent-product align-self-center">
              <v-popover
                v-if="currentJewelSelection.productType === 'EXHIBITORS' && $te('tooltip-' + option.type + '-exhibitors')"
                class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                <!-- Popover target -->
                <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                <!-- Content of popover -->
                <template slot="popover">
                  <JewelDescriptionTooltip :description="$t('tooltip-' + option.type + '-exhibitors')">
                  </JewelDescriptionTooltip>
                </template>
              </v-popover>
            </div>
            <p class="text-left pl-5 text-uppercase label-menu">
              {{ $t(`option-${currentJewelSelection.productType}` + '-' + `${option.type}`) }}
            </p>
          </div>
          <div class="pl-5 pt-2">
            <div class="select-wrapper">
              <select class="w-100 select-setting" v-model="skuSelection[index]"
                @change="skuComposition(skuSelection[index], index)">
                <option :value="'null'"></option>
                <option v-for="val in option.values" :key="val.id" :value="val.id" :disabled="val.disabled">
                  {{ val.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3" v-if="
        currentJewelSelection &&
        currentJewelSelection.productType === 'PACKAGING'
      ">
        <div class="option-label row" style="border-left: none !important">
          <div class="
              col-10
              pl-0
              d-inline-block
              position-relative
              align-self-center
            ">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("frame") }}
            </p>
            <!-- <p
            class="text-left pl-5 incisione-label"
            v-if="
              currentJewelSelection &&
              currentJewelSelection.logoPrice &&
              retailPerc === 1
            "
          >
            ( {{ $t("addLogo") }} +
            {{ currentJewelSelection.logoPrice.toFixed(2).replace(".", ",") }}€)
          </p> -->
          </div>
          <div class="col-2 pl-0">
            <input type="checkbox" class="w-100 pt-1 checkbox-setting" v-model="frame" :disabled="!jewelDescription"
              @change="selectionFrame" />
          </div>
        </div>
      </div>

      <div class="col-12 mb-3" v-if="
        currentJewelSelection &&
        currentJewelSelection.productType == 'PACKAGING'
      ">
        <div class="option-label row" style="border-left: none !important">
          <div class="
              col-10
              pl-0
              d-inline-block
              position-relative
              align-self-center
            ">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("engraveYourLogoProduct") }}
            </p>
            <!-- <p
              class="text-left pl-5 incisione-label"
              v-if="
                currentJewelSelection &&
                currentJewelSelection.logoPrice &&
                retailPerc === 1
              "
            >
              ( {{ $t("addLogo") }} +
              {{
                currentJewelSelection.logoPrice.toFixed(2).replace(".", ",")
              }}€)
            </p> -->
          </div>
          <div class="col-2 pl-0">
            <input type="checkbox" class="w-100 pt-1 checkbox-setting" v-model="logo" :disabled="!jewelDescription"
              @change="logoSelection()" />
          </div>
        </div>
      </div>

      <div class="col-12 mb-3" v-if="
        currentJewelSelection && currentJewelSelection.productType == 'KIT' && jewelDescription &&
        currentJewelSelection.options[0].values.length != 1
      ">
        <div class="option-label mb-3" style="border-left: none !important">
          <div class="
              col-10
              pl-0
              d-inline-block
              position-relative
              align-self-center
            ">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("addExhibitors") }}
            </p>
            <!-- <p
              class="text-left pl-5 incisione-label"
              v-if="
                currentJewelSelection &&
                currentJewelSelection.logoPrice &&
                retailPerc === 1
              "
            >
              ( {{ $t("addLogo") }} +
              {{
                currentJewelSelection.logoPrice.toFixed(2).replace(".", ",")
              }}€)
            </p> -->
          </div>
          <div class="col-2 pl-0">
            <input type="checkbox" class="w-100 pt-1 checkbox-setting" v-model="exhibitor" :disabled="!jewelDescription ||
              currentJewelSelection.options[0].values.length === 1
              " @change="exhibitorSelection(exhibitor)" />
          </div>
        </div>
        <div class="option-label" style="border-left: none !important"
          v-if="selectedProduct.optionPrice && selectedProduct.optionPrice[0].logoPrice">
          <div class="col-10 pl-0 d-inline-block position-relative">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("engraveYourLogo") }}*

              <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                <!-- Popover target -->
                <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                <!-- Content of popover -->
                <template slot="popover">
                  <JewelDescriptionTooltip :description="$t('tooltipEngraveYourLogo')"></JewelDescriptionTooltip>
                </template>
              </v-popover>
            </p>
            <p class="text-left pl-5 incisione-label" v-if="
              currentJewelSelection &&
              selectedProduct.optionPrice[0].logoPrice &&
              retailPerc === 1
            ">
              ( {{ $t("addLogo") }} +
              {{
                selectedProduct.optionPrice[0].logoPrice.toFixed(2).replace(".", ",")
              }}€)
              <br />
              *{{ $t("onlyForRings") }}
            </p>
          </div>
          <div class="col-2 pl-0">
            <input type="checkbox" class="w-100 pt-1 checkbox- d-flex" v-model="logo" :disabled="!jewelDescription
              " @change="logoSelection()" />
          </div>
        </div>
        <div class="option-label row" style="border-left: none !important"
          v-if="selectedProduct.optionPrice && selectedProduct.optionPrice[0].warrantyPrice">
          <div class="col-10 pl-0 d-inline-block position-relative">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("printWarranties") }}

              <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                <!-- Popover target -->
                <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                <!-- Content of popover -->
                <template slot="popover">
                  <JewelDescriptionTooltip :description="$t('tooltipWarranty')"></JewelDescriptionTooltip>
                </template>
              </v-popover>
            </p>
            <p class="text-left pl-5 incisione-label" v-if="
              currentJewelSelection &&
              selectedProduct.optionPrice[0].warrantyPrice &&
              retailPerc === 1
            ">
              ( {{ $t("addWarranties") }} +
              {{
                selectedProduct.optionPrice[0].warrantyPrice.toFixed(2).replace(".", ",")
              }}€)
            </p>
          </div>
          <div class="col-2 pl-0">
            <input type="checkbox" class="w-100 pt-1 checkbox- d-flex" v-model="warranty" :disabled="!jewelDescription
              " @change="warrantySelection()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Vue from "vue";
import JewelDescriptionTooltip from "./JewelDescriptionTooltip";
import "vue-directive-tooltip/dist/vueDirectiveTooltip.css";

export default {
  name: "ProductSettings",
  components: {
    JewelDescriptionTooltip,
  },
  data: function () {
    return {
      retailPerc: 1,
      skuSelection: [],
      productSku: "",
      frame: false,
      logo: false,
      warranty: false,
      exhibitor: false,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
    };
  },
  computed: mapState({
    currentCategory: (state) => state.productDetail.currentCategory,
    optionsMap: (state) => state.productDetail.optionsMap,
    selectedProduct: (state) => state.productDetail.selectedProduct,
    optionsMapDefault: (state) => state.productDetail.optionsMapDefault,
    jewelDescription: (state) => state.productDetail.jewelDescription,
    currentJewelSelection: (state) => state.productDetail.currentJewelSelection,
    options: (state) => state.productDetail.currentJewelSelection.options,
    preselectedJewel: (state) => state.productDetail.preselectedJewel,
    preselectedLogo: (state) => state.productDetail.preselectedLogo,
    preselectedWarranty: (state) => true /*state.productDetail.preselectedWarranty*/,
  }),
  mounted() {
    this.retailPerc = this.$store.state.productDetail.retailPerc;
    let cheapestJewel;

    //if for KIT
    if (this.$route.params.kit == true) {
      if (this.$route.params.direct) {
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 3
          ) === "-wa"
        ) {
          this.warranty = true;
          this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -3);
          setTimeout(() => {
            this.warrantySelection();
          }, 500);
        }
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 3
          ) === "-l"
        ) {
          this.logo = true;
          this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -2);
          setTimeout(() => {
            this.logoSelection();
          }, 500);
        }
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 3
          ) === "-ex"
        ) {
          this.exhibitor = true;
          this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -3);
          setTimeout(() => {
            this.exhibitorSelection(this.exhibitor);
          }, 500);
        }
      } else {
        if (this.preselectedLogo) {
          this.logo = true;
          setTimeout(() => {
            this.logoSelection();
          }, 500);
        }
        if (this.preselectedWarranty) {
          this.warranty = true;
          setTimeout(() => {
            this.warrantySelection();
          }, 500);
        }
      }
      this.skuComposition((+this.exhibitor).toString(), 0);
    } else {
      if (!this.$route.params.direct) {
        let selectionJewel = [];
        const keysList = Object.assign({}, this.currentJewelSelection.keys);
        Object.keys(keysList).map((key, index) => {
          const k = key.split("|");
          const o = keysList[key];
          o.k = k;
        });

        if (
          Object.keys(keysList).length === 1 &&
          Object.keys(keysList)[0] === ""
        ) {
          cheapestJewel = keysList[""];
          this.skuComposition(cheapestJewel.k[0], 0);
        } else {
          for (const key in keysList) {
            if (Object.hasOwnProperty.call(keysList, key)) {
              const element = keysList[key];
              if (selectionJewel && selectionJewel.length > 0) {
                if (selectionJewel.every((elem) => element.k.includes(elem))) {
                  if (cheapestJewel) {
                    if (
                      element.optionPrice[0].price <
                      cheapestJewel.optionPrice[0].price
                    ) {
                      cheapestJewel = element;
                    }
                  } else {
                    cheapestJewel = element;
                  }
                }
              } else {
                if (cheapestJewel) {
                  if (
                    element.optionPrice[0].price <
                    cheapestJewel.optionPrice[0].price
                  ) {
                    cheapestJewel = element;
                  }
                } else {
                  cheapestJewel = element;
                }
              }
            }
          }
          this.options.forEach((option, idx) => {

            let defaultValue;

            if (this.optionsMapDefault[`${option.type}${this.currentJewelSelection.categoryId}`] &&
              option.values.some((val) => this.optionsMapDefault[`${option.type}${this.currentJewelSelection.categoryId}`].includes(val.id))
            ) {
              defaultValue = option.values.find((a) =>
                this.optionsMapDefault[
                  `${option.type}${this.currentJewelSelection.categoryId}`
                ].includes(a.id)
              ).id;
            }

            this.skuComposition(defaultValue || cheapestJewel.k[idx], idx, option.type);
          });
        }
      } else {
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 2
          ) === "-f"
        ) {
          this.frame = true;
          this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -2);
          setTimeout(() => {
            this.selectionFrame();
          }, 500);
        }
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 2
          ) === "-l"
        ) {
          this.logo = true;
          this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -2);
          setTimeout(() => {
            this.logoSelection();
          }, 500);
        }

        const keysList = Object.assign({}, this.currentJewelSelection.keys);
        Object.keys(keysList).map((key, index) => {
          const k = key.split("|");
          const o = keysList[key];
          o.k = k;
        });

        if (
          Object.keys(keysList).length === 1 &&
          Object.keys(keysList)[0] === ""
        ) {
          cheapestJewel = keysList[""];
          this.skuComposition(cheapestJewel.k[0], 0);
        } else {
          for (const key in keysList) {
            if (Object.hasOwnProperty.call(keysList, key)) {
              const element = keysList[key];
              if (element.sku == this.preselectedJewel.sku) {
                cheapestJewel = element;
              }
            }
          }
          this.options.forEach((option, idx) => {
            this.skuComposition(cheapestJewel.k[idx], idx, option.type);
          });
        }
      }
    }

    Vue.setHeight();
    this.scrollTo();
  },
  methods: {
    ...mapMutations("productDetail", [
      "setValueAndChangeRing",
      "changePrice",
      "addValueToJewel",
      "setFrame",
      "setLogo",
      "setWarranty",
      "setExhibitor",
    ]),
    addToBasketProduct() {
      this.$parent.addToBasketProduct();
    },
    exhibitorSelection(ex) {
      this.exhibitor = ex;
      if (this.exhibitor) {
        let val = this.currentJewelSelection.options[0].values.find(
          (a) => a.id == "1"
        );
        this.currentJewelSelection.itemsInKit.push(val);
      } else {
        this.currentJewelSelection.itemsInKit =
          this.currentJewelSelection.itemsInKit.filter(function (obj) {
            return !obj.id;
          });
      }

      this.setExhibitor({ label: "exhibitor", value: this.exhibitor });

      this.skuComposition((+this.exhibitor).toString(), 0);
    },
    logoSelection() {
      const price = this.logo
        ? this.selectedProduct.optionPrice[0].logoPrice
        : -this.selectedProduct.optionPrice[0].logoPrice;

      this.setLogo({ label: "logo", value: this.logo });
      this.addValueToJewel({
        category: "logo",
        value: this.logo,
      });
      this.changePrice(price);
    },
    warrantySelection() {
      const price = this.warranty
        ? this.selectedProduct.optionPrice[0].warrantyPrice
        : -this.selectedProduct.optionPrice[0].warrantyPrice;

      this.setWarranty({ label: "warranty", value: this.warranty });
      this.addValueToJewel({
        category: "warranty",
        value: this.warranty,
      });
      this.changePrice(price);
    },
    selectionFrame() {
      const price = this.frame
        ? this.selectedProduct.optionPrice[0].framePrice
        : -this.selectedProduct.optionPrice[0].framePrice;

      this.setFrame({ label: "frame", value: this.frame });
      this.addValueToJewel({
        category: "frame",
        value: this.frame,
      });
      this.changePrice(price);
    },
    scrollTo() {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: 0,
        },
        "*"
      );
    },
    skuComposition(value, index, type) {
      this.skuSelection[index] = value;
      // this.productSku = this.skuSelection.join("|");
      this.productSku = this.skuSelection.join("|");
      this.setValueAndChangeRing({
        sku: this.productSku,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
div.option-label {
  border-bottom: 1px solid var(--secondary-color-1);
  padding: 5px 0px;
  font-weight: bold;
  display: flex;
}


.label-menu {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 18px;
  font-weight: bold;
  color: var(--primary-color-1);
  margin: 0;
}

.select-setting {
  border: 1px solid var(--primary-color-1);
  display: initial;
  border-radius: 9px;
  padding: 4px;
  cursor: pointer;
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .label-menu {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 12px;
    color: var(--primary-color-1);
    margin: 0;
  }

  .select-setting {
    font-size: 14px;
  }

  .backing-label {
    border: 1px solid var(--primary-color-1);
    border-radius: 9px;
    padding: 5px 20px;
    font-size: 10px;
  }
}

.backing-label {
  border: 1px solid var(--primary-color-1);
  border-radius: 9px;
  padding: 5px 20px;
}

.backing-label:disabled {
  border: 1px solid var(--primary-color-1);
  border-radius: 9px;
  background-color: rgba(0, 0, 0, 0.16);
  padding: 5px 20px;
}

.backing-label-selected {
  background-color: var(--primary-color-1);
  color: #fff;
}

@media only screen and (max-width: 768px) {
  .label-menu {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 12px;
    color: var(--primary-color-1);
  }

  .select-setting {
    font-size: 14px;
  }

  .backing-label {
    border: 1px solid var(--primary-color-1);
    border-radius: 9px;
    padding: 5px 20px;
    font-size: 10px;
  }
}

.disableImg {
  pointer-events: none;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.16);
}

.label-setting {
  font-size: 25px;
}

.input-incisione {
  border-radius: 9px;
  border: solid 1px #00254b;
  background-color: #ffffff;
}

.backing-img {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}

.incisione-label {
  font-size: 10px;
  margin: 0;
}

[data-popover="stonesDescr"],
[data-popover="chainsDescr"],
[data-popover="backingsDescr"] {
  background: #fff;
  color: #000;
  font-size: 12px;
  height: 120px;
  line-height: 1.5;
}

.info-button-parent-product {
  position: absolute;
  /* right: 17px; */
  z-index: 999;
  left: 94%;
  float: right;
  margin-left: 5px;
}

.info-button {
  background-color: transparent !important;
  border: none;
}

.select-wrapper {}
</style>
